import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render confidentiality section for FAQ Page
 */
const ConfidentialitySection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="confidentiality-section-component"
    >
      <AccordionV2
        testId="confidentiality"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="1. Will the submitted documents be kept confidential?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 pb-2 pt-6">
          <p>
            Access to the submitted documents and information is kept strictly
            to the Award organizing committee comprising key members of the
            Sponsors, and the panel of judges. They are used solely for judging
            and reference purposes and will be kept strictly confidential.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ConfidentialitySection;
